import * as React from 'react'

import { Button } from '../../../../main/components/button'
import { isIpad, isMobile } from '../../../shared/isMobile'
import { EXPANDED_MAP_BODY_CLASSS } from '../../constants/constants'
import mapActionCreators from '../../store/action-creators'
import Treemap from '../../treemap'
import { MapDataRoot } from '../../types'
import * as mapUtils from '../../utils'

interface ExpandProps {
  treemap: Treemap
  data: MapDataRoot
  className?: string
  layoutOptions?: Record<string, any>
}

export function Expand(props: ExpandProps) {
  const onExpand = React.useCallback(() => {
    if (!props.treemap) return

    if (document.body.classList.contains(EXPANDED_MAP_BODY_CLASSS)) {
      document.body.classList.remove(EXPANDED_MAP_BODY_CLASSS)
    } else {
      window.gtag?.('event', 'map-expand', { event_category: 'maps' })
      document.body.classList.add(EXPANDED_MAP_BODY_CLASSS)
    }

    const updatedLayout = mapUtils.getTreemapLayout(
      props.data,
      props.treemap.type,
      props.treemap.settings,
      false,
      props.layoutOptions
    )
    props.treemap.zoom.scale(1)
    mapActionCreators.updateLayout(props.treemap, updatedLayout)

    window.scrollTo(0, 0)
  }, [props])

  if (isMobile() && !isIpad()) return null

  return (
    <Button className={props.className} theme="transparent" leftContent="fullscreen" onClick={onExpand}>
      Fullscreen
    </Button>
  )
}
